import '../../styles/date-13/style.scss';
import "../cookie";
import {unsubscribeLogic} from "../unsubscribe";
import {paymentLogic} from "../paymentPagesLogic";
import {loginPageLogic} from "../login";
import {contactFormLogic} from "../contactForm";
import {countryCityLogic} from "./countryCity";
import "../tw-elements/header";
import "../elements/header";

document.addEventListener("DOMContentLoaded", () => {
  unsubscribeLogic();
  paymentLogic();
  loginPageLogic();
  contactFormLogic();
  countryCityLogic();
});
